import { render, staticRenderFns } from "./gateway-edit.vue?vue&type=template&id=39c182da&scoped=true&"
import script from "./gateway-edit.vue?vue&type=script&lang=js&"
export * from "./gateway-edit.vue?vue&type=script&lang=js&"
import style0 from "./gateway-edit.vue?vue&type=style&index=0&id=39c182da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c182da",
  null
  
)

export default component.exports